import React, { Fragment } from "react";
import { Box, Divider, Typography } from "@mui/material";
import Message from "./Message/Message";
import moment from "moment";

function Results({
  entity = null,
  tabular = null,
  messages,
  relatedDocsFromStreaming = [],
  handleEntityChange = () => {},
  handleTabularChange = () => {},
  messageRefs,
  isStreaming,
  queryContainerHeight,
  selectedSource,
  setSelectedSource,
  isMetadataLoading = false,
  saved = false,
  onMessageUpdate = () => {},
  selectedRelatedDoc,
  setSelectedRelatedDoc,
  selectedFileFromStream,
  onSelectedFileFromStreamChange,
  isolationMarkup,
  onIsolationMarkupChange,
  selectedIsolationMarkup,
  onSelectedIsolationMarkupChange,
  lastStreamedMessageId,
}) {
  return (
    <Box>
      {messages.map((message, i) => {
        return (
          <Fragment key={i}>
            <Message
              entity={entity}
              tabular={tabular}
              message={message}
              messageRefs={messageRefs}
              relatedDocsFromStreaming={relatedDocsFromStreaming}
              handleEntityChange={handleEntityChange}
              handleTabularChange={handleTabularChange}
              queryContainerHeight={queryContainerHeight}
              isStreaming={isStreaming}
              isLastMessage={i === messages.length - 1}
              isFirstMessage={i === 0}
              numOfMessages={messages.length}
              isMetadataLoading={isMetadataLoading}
              saved={saved}
              onMessageUpdate={onMessageUpdate}
              selectedSource={selectedSource}
              setSelectedSource={setSelectedSource}
              selectedRelatedDoc={selectedRelatedDoc}
              setSelectedRelatedDoc={setSelectedRelatedDoc}
              selectedFileFromStream={selectedFileFromStream}
              onSelectedFileFromStreamChange={onSelectedFileFromStreamChange}
              isolationMarkup={isolationMarkup}
              onIsolationMarkupChange={onIsolationMarkupChange}
              selectedIsolationMarkup={selectedIsolationMarkup}
              onSelectedIsolationMarkupChange={onSelectedIsolationMarkupChange}
              lastStreamedMessageId={lastStreamedMessageId}
            />
            {i === 0 &&
              (messages.length > 1 || (messages.length === 1 && isStreaming)) &&
              !saved && (
                <Box display="flex" alignItems="center" gap={2} mb={7.5}>
                  <Typography variant="overline" color={"textSecondary"}>
                    Follow-up
                  </Typography>
                  <Divider sx={{ flexGrow: 1 }} />
                </Box>
              )}
          </Fragment>
        );
      })}
    </Box>
  );
}

export function groupMessagesByDate(items) {
  const today = moment();
  const yesterday = moment().subtract(1, "day");
  const groups = {};
  items.forEach((item) => {
    const date = moment(item["query"]["created_at"]);
    const dayFormat = date.format("ddd, DD MMM");
    if (date.isSame(today, "day")) {
      if (groups["Today"]) {
        groups["Today"].push(item);
      } else {
        groups["Today"] = [item];
      }
    } else if (date.isSame(yesterday, "day")) {
      if (groups["Yesterday"]) {
        groups["Yesterday"].push(item);
      } else {
        groups["Yesterday"] = [item];
      }
    } else {
      if (groups[dayFormat]) {
        groups[dayFormat].push(item);
      } else {
        groups[dayFormat] = [item];
      }
    }
  });

  const groupsArray = Object.keys(groups).map((date) => {
    return {
      date,
      items: groups[date],
    };
  });
  return groupsArray;
}

export default Results;
